import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dot: {
    width: 8,
    height: 8,
    margin: 2,
    borderRadius: 20,
  },
  complete: {
    backgroundColor: theme.palette.grey[500],
  },
  incomplete: {
    backgroundColor: theme.palette.grey[100],
  },
}));

const DotProgress = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {Array.from(Array(props.stepsLength).keys()).map((step, index) => (
        <div
          key={index}
          className={
            index < props.stepsCompleted
              ? `${classes.dot} ${classes.complete}`
              : `${classes.dot} ${classes.incomplete}`
          }
        />
      ))}
    </div>
  );
};

DotProgress.propTypes = {
  stepsLength: PropTypes.number,
  stepsCompleted: PropTypes.number,
};

DotProgress.defaultProps = {
  stepsLength: 1,
  stepsCompleted: 0,
};

export default DotProgress;
